import React from "react";
import ProductSync from "../components/ProductSync";

export const ProductSyncPage = () => {
  return (
    <div>
      <ProductSync />
    </div>
  );
};
